<app-page-body-content>
    <div class="loading">
        <app-loading-spinner/>
    </div>
</app-page-body-content>
